module.exports = __webpack_public_path__ + "static/media/menu-light-e.5bc73bc0.svg";